/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '@angular/common';
import * as import2 from '../../ui-elements/image/image-cache.directive';
import * as import3 from '../../ui-elements/image/cached-image.service';
import * as import4 from 'ng2-translate/src/translate.pipe';
import * as import5 from 'ng2-translate/src/translate.service';
import * as import6 from '../../ui-elements/toggle/toggle.component.ngfactory';
import * as import7 from '../../ui-elements/toggle/toggle.component';
import * as import8 from '../../html-utils/css-var.directive';
import * as import9 from '../../ui-elements/touchable.directive';
import * as import10 from '../../buttons/link/link.component.ngfactory';
import * as import11 from '../../buttons/link/link.component';
import * as import12 from '../store-status-panel/store-status-panel.component.ngfactory';
import * as import13 from '../store-status-panel/store-status-panel.component';
import * as import14 from '../../ordering-context/ordering-context.model';
import * as import15 from '../../buttons/button/button.component.ngfactory';
import * as import16 from '../../buttons/button/button.component';
import * as import17 from '../../orchestration/session.model';
import * as import18 from '../../orchestration/responsive.service';
import * as import19 from '../store-map-panel/store-map-panel.component.ngfactory';
import * as import20 from '../store-map-panel/store-map-panel.component';
import * as import21 from '../distance.pipe';
import * as import22 from '../../orchestration/responsive.directive';
import * as import23 from '../../orchestration/navigation.service';
import * as import24 from './store-details-panel.component';
const styles_StoreDetailsPanelComponent:any[] = ([] as any[]);
export const RenderType_StoreDetailsPanelComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_StoreDetailsPanelComponent,
  data: {}
}
);
function View_StoreDetailsPanelComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),6,'div',[[
        'class',
        'store-image'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'img',[[
        'class',
        'store-image-object'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import1.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod(['emptyImg']),
    import0.ɵdid(16384,(null as any),0,import2.ImageCacheDirective,[
      import0.ElementRef,
      import0.Renderer2,
      import3.CachedImageService
    ]
      ,{imageData: [
        0,
        'imageData'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 'store-image-object';
    const currVal_1:any = ck(v,4,0,(!((co.store.image == null)? (null as any): co.store.image.id) && !((co.store.image == null)? (null as any): co.store.image.image)));
    ck(v,3,0,currVal_0,currVal_1);
    const currVal_2:any = co.store.image;
    ck(v,5,0,currVal_2);
  },(null as any));
}
function View_StoreDetailsPanelComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'store-main-header-state'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                ',
      '\n            '
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.store.state;
    ck(v,1,0,currVal_0);
  });
}
function View_StoreDetailsPanelComponent_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'store-main-header-distance'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                ',
      '\n            '
    ]
    )),
    import0.ɵppd(1),
    import0.ɵpod(['distance']),
    import0.ɵpid(131072,import4.TranslatePipe,[
      import5.TranslateService,
      import0.ChangeDetectorRef
    ]
    )
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,1,0,import0.ɵnov(v,4).transform('woa.label.store-details.distance',ck(v,3,0,import0.ɵunv(v,1,0,ck(v,2,0,import0.ɵnov((<any>v.parent),0),co.store.distance)))));
    ck(v,1,0,currVal_0);
  });
}
function View_StoreDetailsPanelComponent_4(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),6,'div',[[
        'class',
        'store-main-body-details-static-image store-image'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'img',[[
        'class',
        'store-image-object'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import1.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod(['emptyImg']),
    import0.ɵdid(16384,(null as any),0,import2.ImageCacheDirective,[
      import0.ElementRef,
      import0.Renderer2,
      import3.CachedImageService
    ]
      ,{imageData: [
        0,
        'imageData'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 'store-image-object';
    const currVal_1:any = ck(v,4,0,(!((co.store.image == null)? (null as any): co.store.image.id) && !((co.store.image == null)? (null as any): co.store.image.image)));
    ck(v,3,0,currVal_0,currVal_1);
    const currVal_2:any = co.store.image;
    ck(v,5,0,currVal_2);
  },(null as any));
}
function View_StoreDetailsPanelComponent_6(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'store-main-body-details-static-info-text-details-detail'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                                    ',
      '\n                                '
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.store.description;
    ck(v,1,0,currVal_0);
  });
}
function View_StoreDetailsPanelComponent_7(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'store-main-body-details-static-info-text-details-detail'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                                    ',
      ', ',
      ' ',
      '\n                                '
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.store.street;
    const currVal_1:any = co.store.city;
    const currVal_2:any = (co.store.postcode? co.store.postcode: co.store.state);
    ck(v,1,0,currVal_0,currVal_1,currVal_2);
  });
}
function View_StoreDetailsPanelComponent_8(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-toggle',[[
        'class',
        'store-main-body-details-static-info-text-toggle'
      ]
    ],(null as any),(null as any),(null as any),import6.View_ToggleComponent_0,import6.RenderType_ToggleComponent)),
      import0.ɵdid(573440,(null as any),0,import7.ToggleComponent,[import0.ChangeDetectorRef],{active: [
        0,
        'active'
      ]
    },(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:boolean = !co.textCollapsed;
    ck(v,1,0,currVal_0);
  },(null as any));
}
function View_StoreDetailsPanelComponent_5(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,[[
        'text',
        1
      ]
    ],(null as any),18,'div',[
      [
        'class',
        'store-main-body-details-static-info-text'
      ]
      ,
      [
        'woa-touchable',
        ''
      ]

    ]
      ,(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.toggleText(import0.ɵnov(v,0))) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import1.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod(['collapsible']),
      import0.ɵdid(671744,(null as any),0,import8.CssVarDirective,[import0.ElementRef],{cssVars: [
        0,
        'cssVars'
      ]
    },(null as any)),
    import0.ɵpod(['--line-height']),
    import0.ɵdid(4210688,(null as any),0,import9.TouchableDirective,[import0.ElementRef],(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n                            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'store-main-body-details-static-info-text-details'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_StoreDetailsPanelComponent_6)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_StoreDetailsPanelComponent_7)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_StoreDetailsPanelComponent_8)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                        ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 'store-main-body-details-static-info-text';
    const currVal_1:any = ck(v,2,0,co.canCollapseText(import0.ɵnov(v,0)));
    ck(v,1,0,currVal_0,currVal_1);
    const currVal_2:any = ck(v,4,0,(co.TEXT_LINE_HEIGHT + 'px'));
    ck(v,3,0,currVal_2);
    const currVal_3:any = co.canShowDescription;
    ck(v,10,0,currVal_3);
    const currVal_4:any = co.showAddress;
    ck(v,13,0,currVal_4);
    const currVal_5:any = co.canCollapseText(import0.ɵnov(v,0));
    ck(v,17,0,currVal_5);
  },(null as any));
}
function View_StoreDetailsPanelComponent_9(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-link',[[
        'class',
        'store-main-body-details-static-info-telephone'
      ]
      ],(null as any),[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.callPhone()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import10.View_LinkComponent_0,import10.RenderType_LinkComponent)),
    import0.ɵdid(49152,(null as any),0,import11.LinkComponent,([] as any[]),{
      label: [
        0,
        'label'
      ]
      ,
      link: [
        1,
        'link'
      ]
      ,
      translationParams: [
        2,
        'translationParams'
      ]
      ,
      disabled: [
        3,
        'disabled'
      ]

    }
    ,{onActivate: 'onActivate'}),
    import0.ɵpod(['number'])
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 'woa.label.store-details.phoneNumber';
    const currVal_1:any = 'woa.button.store-details.phoneNumber';
    const currVal_2:any = ck(v,2,0,co.store.telephone);
    const currVal_3:any = co.sessionModel.nativeMode;
    ck(v,1,0,currVal_0,currVal_1,currVal_2,currVal_3);
  },(null as any));
}
function View_StoreDetailsPanelComponent_10(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-link',[[
        'class',
        'store-main-body-details-static-info-more'
      ]
      ],(null as any),[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.showStoreDetails()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import10.View_LinkComponent_0,import10.RenderType_LinkComponent)),
      import0.ɵdid(49152,(null as any),0,import11.LinkComponent,([] as any[]),{link: [
        0,
        'link'
      ]
    },{onActivate: 'onActivate'})
  ]
  ,(ck,v) => {
    const currVal_0:any = 'woa.button.store-details.moreDetails';
    ck(v,1,0,currVal_0);
  },(null as any));
}
function View_StoreDetailsPanelComponent_11(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-store-status-panel',[[
        'class',
        'store-main-body-details-status'
      ]
    ],(null as any),(null as any),(null as any),import12.View_StoreStatusPanelComponent_0,import12.RenderType_StoreStatusPanelComponent)),
    import0.ɵdid(49152,(null as any),0,import13.StoreStatusPanelComponent,[import14.OrderingContextModel],{
      store: [
        0,
        'store'
      ]
      ,
      filteredOrderType: [
        1,
        'filteredOrderType'
      ]

    }
    ,(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.store;
    const currVal_1:any = co.filteredOrderType;
    ck(v,1,0,currVal_0,currVal_1);
  },(null as any));
}
function View_StoreDetailsPanelComponent_14(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-button',[[
        'class',
        'store-main-body-actions-options-option'
      ]
    ],[
      [
        2,
        'override-flat-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-flat-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-border-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'invisible',
        (null as any)
      ]
      ,
      [
        2,
        'hovered',
        (null as any)
      ]
      ,
      [
        2,
        'native',
        (null as any)
      ]
      ,
      [
        2,
        'woa-button',
        (null as any)
      ]
      ,
      [
        2,
        'tier-first',
        (null as any)
      ]
      ,
      [
        2,
        'tier-second',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-high',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-low',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-affirmative',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-dissuasive',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-negative',
        (null as any)
      ]
      ,
      [
        2,
        'shape-square',
        (null as any)
      ]
      ,
      [
        2,
        'shape-rounded',
        (null as any)
      ]
      ,
      [
        2,
        'shape-oval',
        (null as any)
      ]
      ,
      [
        2,
        'style-flat',
        (null as any)
      ]
      ,
      [
        2,
        'style-outline',
        (null as any)
      ]
      ,
      [
        2,
        'style-raised',
        (null as any)
      ]
      ,
      [
        2,
        'layout-vertical',
        (null as any)
      ]
      ,
      [
        2,
        'layout-horizontal',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('click' === en)) {
        const pd_1:any = ((<any>co.orderHere(co.OrderType.ORDER_AT_TABLE)) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import15.View_ButtonComponent_0,import15.RenderType_ButtonComponent)),
    import0.ɵdid(245760,(null as any),0,import16.ButtonComponent,[
      import0.ElementRef,
      import17.SessionModel,
      import0.ChangeDetectorRef,
      import18.ResponsiveService
    ]
    ,{
      label: [
        0,
        'label'
      ]
      ,
      tier: [
        1,
        'tier'
      ]
      ,
      prominence: [
        2,
        'prominence'
      ]

    }
    ,(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_27:any = 'woa.button.store-details.orderAtTable';
    const currVal_28:any = co.ButtonTier.SECOND;
    const currVal_29:any = co.ButtonProminence.LOW;
    ck(v,1,0,currVal_27,currVal_28,currVal_29);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).overrideFlatBackgroundColor;
    const currVal_1:any = import0.ɵnov(v,1).overrideFlatForegroundColor;
    const currVal_2:any = import0.ɵnov(v,1).overrideOutlineBackgroundColor;
    const currVal_3:any = import0.ɵnov(v,1).overrideOutlineForegroundColor;
    const currVal_4:any = import0.ɵnov(v,1).overrideOutlineBorderColor;
    const currVal_5:any = import0.ɵnov(v,1).overrideRaisedBackgroundColor;
    const currVal_6:any = import0.ɵnov(v,1).overrideRaisedForegroundColor;
    const currVal_7:any = import0.ɵnov(v,1).disabled;
    const currVal_8:any = import0.ɵnov(v,1).invisible;
    const currVal_9:any = import0.ɵnov(v,1).hovered;
    const currVal_10:any = import0.ɵnov(v,1).native;
    const currVal_11:any = import0.ɵnov(v,1).button;
    const currVal_12:any = import0.ɵnov(v,1).firstTier;
    const currVal_13:any = import0.ɵnov(v,1).secondTier;
    const currVal_14:any = import0.ɵnov(v,1).highProminence;
    const currVal_15:any = import0.ɵnov(v,1).lowProminence;
    const currVal_16:any = import0.ɵnov(v,1).affirmativeConnotation;
    const currVal_17:any = import0.ɵnov(v,1).dissuasiveConnotation;
    const currVal_18:any = import0.ɵnov(v,1).negativeConnotation;
    const currVal_19:any = import0.ɵnov(v,1).squareShape;
    const currVal_20:any = import0.ɵnov(v,1).roundedShape;
    const currVal_21:any = import0.ɵnov(v,1).ovalShape;
    const currVal_22:any = import0.ɵnov(v,1).flatStyle;
    const currVal_23:any = import0.ɵnov(v,1).outlineStyle;
    const currVal_24:any = import0.ɵnov(v,1).raisedStyle;
    const currVal_25:any = import0.ɵnov(v,1).verticalLayout;
    const currVal_26:any = import0.ɵnov(v,1).horizontalLayout;
    ck(v,0,1,[
      currVal_0,
      currVal_1,
      currVal_2,
      currVal_3,
      currVal_4,
      currVal_5,
      currVal_6,
      currVal_7,
      currVal_8,
      currVal_9,
      currVal_10,
      currVal_11,
      currVal_12,
      currVal_13,
      currVal_14,
      currVal_15,
      currVal_16,
      currVal_17,
      currVal_18,
      currVal_19,
      currVal_20,
      currVal_21,
      currVal_22,
      currVal_23,
      currVal_24,
      currVal_25,
      currVal_26
    ]
    );
  });
}
function View_StoreDetailsPanelComponent_15(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-button',[[
        'class',
        'store-main-body-actions-options-option'
      ]
    ],[
      [
        2,
        'override-flat-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-flat-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-border-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'invisible',
        (null as any)
      ]
      ,
      [
        2,
        'hovered',
        (null as any)
      ]
      ,
      [
        2,
        'native',
        (null as any)
      ]
      ,
      [
        2,
        'woa-button',
        (null as any)
      ]
      ,
      [
        2,
        'tier-first',
        (null as any)
      ]
      ,
      [
        2,
        'tier-second',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-high',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-low',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-affirmative',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-dissuasive',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-negative',
        (null as any)
      ]
      ,
      [
        2,
        'shape-square',
        (null as any)
      ]
      ,
      [
        2,
        'shape-rounded',
        (null as any)
      ]
      ,
      [
        2,
        'shape-oval',
        (null as any)
      ]
      ,
      [
        2,
        'style-flat',
        (null as any)
      ]
      ,
      [
        2,
        'style-outline',
        (null as any)
      ]
      ,
      [
        2,
        'style-raised',
        (null as any)
      ]
      ,
      [
        2,
        'layout-vertical',
        (null as any)
      ]
      ,
      [
        2,
        'layout-horizontal',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('click' === en)) {
        const pd_1:any = ((<any>co.orderHere(co.OrderType.ORDER_AHEAD)) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import15.View_ButtonComponent_0,import15.RenderType_ButtonComponent)),
    import0.ɵdid(245760,(null as any),0,import16.ButtonComponent,[
      import0.ElementRef,
      import17.SessionModel,
      import0.ChangeDetectorRef,
      import18.ResponsiveService
    ]
    ,{
      label: [
        0,
        'label'
      ]
      ,
      tier: [
        1,
        'tier'
      ]
      ,
      prominence: [
        2,
        'prominence'
      ]

    }
    ,(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_27:any = 'woa.button.store-details.orderAhead';
    const currVal_28:any = co.ButtonTier.SECOND;
    const currVal_29:any = co.ButtonProminence.LOW;
    ck(v,1,0,currVal_27,currVal_28,currVal_29);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).overrideFlatBackgroundColor;
    const currVal_1:any = import0.ɵnov(v,1).overrideFlatForegroundColor;
    const currVal_2:any = import0.ɵnov(v,1).overrideOutlineBackgroundColor;
    const currVal_3:any = import0.ɵnov(v,1).overrideOutlineForegroundColor;
    const currVal_4:any = import0.ɵnov(v,1).overrideOutlineBorderColor;
    const currVal_5:any = import0.ɵnov(v,1).overrideRaisedBackgroundColor;
    const currVal_6:any = import0.ɵnov(v,1).overrideRaisedForegroundColor;
    const currVal_7:any = import0.ɵnov(v,1).disabled;
    const currVal_8:any = import0.ɵnov(v,1).invisible;
    const currVal_9:any = import0.ɵnov(v,1).hovered;
    const currVal_10:any = import0.ɵnov(v,1).native;
    const currVal_11:any = import0.ɵnov(v,1).button;
    const currVal_12:any = import0.ɵnov(v,1).firstTier;
    const currVal_13:any = import0.ɵnov(v,1).secondTier;
    const currVal_14:any = import0.ɵnov(v,1).highProminence;
    const currVal_15:any = import0.ɵnov(v,1).lowProminence;
    const currVal_16:any = import0.ɵnov(v,1).affirmativeConnotation;
    const currVal_17:any = import0.ɵnov(v,1).dissuasiveConnotation;
    const currVal_18:any = import0.ɵnov(v,1).negativeConnotation;
    const currVal_19:any = import0.ɵnov(v,1).squareShape;
    const currVal_20:any = import0.ɵnov(v,1).roundedShape;
    const currVal_21:any = import0.ɵnov(v,1).ovalShape;
    const currVal_22:any = import0.ɵnov(v,1).flatStyle;
    const currVal_23:any = import0.ɵnov(v,1).outlineStyle;
    const currVal_24:any = import0.ɵnov(v,1).raisedStyle;
    const currVal_25:any = import0.ɵnov(v,1).verticalLayout;
    const currVal_26:any = import0.ɵnov(v,1).horizontalLayout;
    ck(v,0,1,[
      currVal_0,
      currVal_1,
      currVal_2,
      currVal_3,
      currVal_4,
      currVal_5,
      currVal_6,
      currVal_7,
      currVal_8,
      currVal_9,
      currVal_10,
      currVal_11,
      currVal_12,
      currVal_13,
      currVal_14,
      currVal_15,
      currVal_16,
      currVal_17,
      currVal_18,
      currVal_19,
      currVal_20,
      currVal_21,
      currVal_22,
      currVal_23,
      currVal_24,
      currVal_25,
      currVal_26
    ]
    );
  });
}
function View_StoreDetailsPanelComponent_16(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-button',[[
        'class',
        'store-main-body-actions-options-option'
      ]
    ],[
      [
        2,
        'override-flat-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-flat-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-border-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'invisible',
        (null as any)
      ]
      ,
      [
        2,
        'hovered',
        (null as any)
      ]
      ,
      [
        2,
        'native',
        (null as any)
      ]
      ,
      [
        2,
        'woa-button',
        (null as any)
      ]
      ,
      [
        2,
        'tier-first',
        (null as any)
      ]
      ,
      [
        2,
        'tier-second',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-high',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-low',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-affirmative',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-dissuasive',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-negative',
        (null as any)
      ]
      ,
      [
        2,
        'shape-square',
        (null as any)
      ]
      ,
      [
        2,
        'shape-rounded',
        (null as any)
      ]
      ,
      [
        2,
        'shape-oval',
        (null as any)
      ]
      ,
      [
        2,
        'style-flat',
        (null as any)
      ]
      ,
      [
        2,
        'style-outline',
        (null as any)
      ]
      ,
      [
        2,
        'style-raised',
        (null as any)
      ]
      ,
      [
        2,
        'layout-vertical',
        (null as any)
      ]
      ,
      [
        2,
        'layout-horizontal',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('click' === en)) {
        const pd_1:any = ((<any>co.orderHere(co.OrderType.ORDER_DELIVERY)) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import15.View_ButtonComponent_0,import15.RenderType_ButtonComponent)),
    import0.ɵdid(245760,(null as any),0,import16.ButtonComponent,[
      import0.ElementRef,
      import17.SessionModel,
      import0.ChangeDetectorRef,
      import18.ResponsiveService
    ]
    ,{
      label: [
        0,
        'label'
      ]
      ,
      tier: [
        1,
        'tier'
      ]
      ,
      prominence: [
        2,
        'prominence'
      ]

    }
    ,(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_27:any = 'woa.button.store-details.orderDelivery';
    const currVal_28:any = co.ButtonTier.SECOND;
    const currVal_29:any = co.ButtonProminence.LOW;
    ck(v,1,0,currVal_27,currVal_28,currVal_29);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).overrideFlatBackgroundColor;
    const currVal_1:any = import0.ɵnov(v,1).overrideFlatForegroundColor;
    const currVal_2:any = import0.ɵnov(v,1).overrideOutlineBackgroundColor;
    const currVal_3:any = import0.ɵnov(v,1).overrideOutlineForegroundColor;
    const currVal_4:any = import0.ɵnov(v,1).overrideOutlineBorderColor;
    const currVal_5:any = import0.ɵnov(v,1).overrideRaisedBackgroundColor;
    const currVal_6:any = import0.ɵnov(v,1).overrideRaisedForegroundColor;
    const currVal_7:any = import0.ɵnov(v,1).disabled;
    const currVal_8:any = import0.ɵnov(v,1).invisible;
    const currVal_9:any = import0.ɵnov(v,1).hovered;
    const currVal_10:any = import0.ɵnov(v,1).native;
    const currVal_11:any = import0.ɵnov(v,1).button;
    const currVal_12:any = import0.ɵnov(v,1).firstTier;
    const currVal_13:any = import0.ɵnov(v,1).secondTier;
    const currVal_14:any = import0.ɵnov(v,1).highProminence;
    const currVal_15:any = import0.ɵnov(v,1).lowProminence;
    const currVal_16:any = import0.ɵnov(v,1).affirmativeConnotation;
    const currVal_17:any = import0.ɵnov(v,1).dissuasiveConnotation;
    const currVal_18:any = import0.ɵnov(v,1).negativeConnotation;
    const currVal_19:any = import0.ɵnov(v,1).squareShape;
    const currVal_20:any = import0.ɵnov(v,1).roundedShape;
    const currVal_21:any = import0.ɵnov(v,1).ovalShape;
    const currVal_22:any = import0.ɵnov(v,1).flatStyle;
    const currVal_23:any = import0.ɵnov(v,1).outlineStyle;
    const currVal_24:any = import0.ɵnov(v,1).raisedStyle;
    const currVal_25:any = import0.ɵnov(v,1).verticalLayout;
    const currVal_26:any = import0.ɵnov(v,1).horizontalLayout;
    ck(v,0,1,[
      currVal_0,
      currVal_1,
      currVal_2,
      currVal_3,
      currVal_4,
      currVal_5,
      currVal_6,
      currVal_7,
      currVal_8,
      currVal_9,
      currVal_10,
      currVal_11,
      currVal_12,
      currVal_13,
      currVal_14,
      currVal_15,
      currVal_16,
      currVal_17,
      currVal_18,
      currVal_19,
      currVal_20,
      currVal_21,
      currVal_22,
      currVal_23,
      currVal_24,
      currVal_25,
      currVal_26
    ]
    );
  });
}
function View_StoreDetailsPanelComponent_13(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),17,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'store-main-body-actions-label'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import0.ɵpid(131072,import4.TranslatePipe,[
      import5.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'store-main-body-actions-options'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_StoreDetailsPanelComponent_14)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_StoreDetailsPanelComponent_15)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_StoreDetailsPanelComponent_16)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_1:any = co.canOrder(co.OrderType.ORDER_AT_TABLE);
    ck(v,9,0,currVal_1);
    const currVal_2:any = co.canOrder(co.OrderType.ORDER_AHEAD);
    ck(v,12,0,currVal_2);
    const currVal_3:any = co.canOrder(co.OrderType.ORDER_DELIVERY);
    ck(v,15,0,currVal_3);
  },(ck,v) => {
    const currVal_0:any = import0.ɵunv(v,3,0,import0.ɵnov(v,4).transform('woa.button.store-details.orderHere'));
    ck(v,3,0,currVal_0);
  });
}
function View_StoreDetailsPanelComponent_17(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-button',[[
        'class',
        'store-main-body-actions-options-option'
      ]
    ],[
      [
        2,
        'override-flat-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-flat-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-border-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'invisible',
        (null as any)
      ]
      ,
      [
        2,
        'hovered',
        (null as any)
      ]
      ,
      [
        2,
        'native',
        (null as any)
      ]
      ,
      [
        2,
        'woa-button',
        (null as any)
      ]
      ,
      [
        2,
        'tier-first',
        (null as any)
      ]
      ,
      [
        2,
        'tier-second',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-high',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-low',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-affirmative',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-dissuasive',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-negative',
        (null as any)
      ]
      ,
      [
        2,
        'shape-square',
        (null as any)
      ]
      ,
      [
        2,
        'shape-rounded',
        (null as any)
      ]
      ,
      [
        2,
        'shape-oval',
        (null as any)
      ]
      ,
      [
        2,
        'style-flat',
        (null as any)
      ]
      ,
      [
        2,
        'style-outline',
        (null as any)
      ]
      ,
      [
        2,
        'style-raised',
        (null as any)
      ]
      ,
      [
        2,
        'layout-vertical',
        (null as any)
      ]
      ,
      [
        2,
        'layout-horizontal',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('click' === en)) {
        const pd_1:any = ((<any>co.orderHere()) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import15.View_ButtonComponent_0,import15.RenderType_ButtonComponent)),
    import0.ɵdid(245760,(null as any),0,import16.ButtonComponent,[
      import0.ElementRef,
      import17.SessionModel,
      import0.ChangeDetectorRef,
      import18.ResponsiveService
    ]
    ,{
      label: [
        0,
        'label'
      ]
      ,
      tier: [
        1,
        'tier'
      ]
      ,
      prominence: [
        2,
        'prominence'
      ]

    }
    ,(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_27:any = 'woa.button.store-details.orderHere';
    const currVal_28:any = co.ButtonTier.SECOND;
    const currVal_29:any = co.ButtonProminence.LOW;
    ck(v,1,0,currVal_27,currVal_28,currVal_29);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).overrideFlatBackgroundColor;
    const currVal_1:any = import0.ɵnov(v,1).overrideFlatForegroundColor;
    const currVal_2:any = import0.ɵnov(v,1).overrideOutlineBackgroundColor;
    const currVal_3:any = import0.ɵnov(v,1).overrideOutlineForegroundColor;
    const currVal_4:any = import0.ɵnov(v,1).overrideOutlineBorderColor;
    const currVal_5:any = import0.ɵnov(v,1).overrideRaisedBackgroundColor;
    const currVal_6:any = import0.ɵnov(v,1).overrideRaisedForegroundColor;
    const currVal_7:any = import0.ɵnov(v,1).disabled;
    const currVal_8:any = import0.ɵnov(v,1).invisible;
    const currVal_9:any = import0.ɵnov(v,1).hovered;
    const currVal_10:any = import0.ɵnov(v,1).native;
    const currVal_11:any = import0.ɵnov(v,1).button;
    const currVal_12:any = import0.ɵnov(v,1).firstTier;
    const currVal_13:any = import0.ɵnov(v,1).secondTier;
    const currVal_14:any = import0.ɵnov(v,1).highProminence;
    const currVal_15:any = import0.ɵnov(v,1).lowProminence;
    const currVal_16:any = import0.ɵnov(v,1).affirmativeConnotation;
    const currVal_17:any = import0.ɵnov(v,1).dissuasiveConnotation;
    const currVal_18:any = import0.ɵnov(v,1).negativeConnotation;
    const currVal_19:any = import0.ɵnov(v,1).squareShape;
    const currVal_20:any = import0.ɵnov(v,1).roundedShape;
    const currVal_21:any = import0.ɵnov(v,1).ovalShape;
    const currVal_22:any = import0.ɵnov(v,1).flatStyle;
    const currVal_23:any = import0.ɵnov(v,1).outlineStyle;
    const currVal_24:any = import0.ɵnov(v,1).raisedStyle;
    const currVal_25:any = import0.ɵnov(v,1).verticalLayout;
    const currVal_26:any = import0.ɵnov(v,1).horizontalLayout;
    ck(v,0,1,[
      currVal_0,
      currVal_1,
      currVal_2,
      currVal_3,
      currVal_4,
      currVal_5,
      currVal_6,
      currVal_7,
      currVal_8,
      currVal_9,
      currVal_10,
      currVal_11,
      currVal_12,
      currVal_13,
      currVal_14,
      currVal_15,
      currVal_16,
      currVal_17,
      currVal_18,
      currVal_19,
      currVal_20,
      currVal_21,
      currVal_22,
      currVal_23,
      currVal_24,
      currVal_25,
      currVal_26
    ]
    );
  });
}
function View_StoreDetailsPanelComponent_12(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'store-main-body-actions'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_StoreDetailsPanelComponent_13)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_StoreDetailsPanelComponent_17)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.canShowOrderTypes;
    ck(v,3,0,currVal_0);
    const currVal_1:boolean = !co.canShowOrderTypes;
    ck(v,6,0,currVal_1);
  },(null as any));
}
function View_StoreDetailsPanelComponent_19(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-link',[[
        'class',
        'store-main-location-link'
      ]
      ],(null as any),[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.getDirections()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import10.View_LinkComponent_0,import10.RenderType_LinkComponent)),
      import0.ɵdid(49152,(null as any),0,import11.LinkComponent,([] as any[]),{link: [
        0,
        'link'
      ]
    },{onActivate: 'onActivate'})
  ]
  ,(ck,v) => {
    const currVal_0:any = 'woa.button.store-details.directions';
    ck(v,1,0,currVal_0);
  },(null as any));
}
function View_StoreDetailsPanelComponent_18(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'store-main-location'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'store-main-location-main'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-store-map-panel',[[
        'class',
        'store-main-location-main-map'
      ]
    ],(null as any),(null as any),(null as any),import19.View_StoreMapPanelComponent_0,import19.RenderType_StoreMapPanelComponent)),
      import0.ɵdid(49152,(null as any),0,import20.StoreMapPanelComponent,([] as any[]),{store: [
        0,
        'store'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_StoreDetailsPanelComponent_19)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.store;
    ck(v,5,0,currVal_0);
    const currVal_1:any = ((co.store.latitude && co.store.longitude) && !co.sessionModel.nativeMode);
    ck(v,9,0,currVal_1);
  },(null as any));
}
export function View_StoreDetailsPanelComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵpid(0,import21.DistancePipe,([] as any[])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),57,'div',[
      [
        'class',
        'store'
      ]
      ,
      [
        'woa-responsive',
        ''
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import1.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod([
      'summary',
      'with-actions',
      'with-store-image',
      'with-map'
    ]
    ),
    import0.ɵdid(737280,(null as any),0,import22.ResponsiveDirective,[
      import0.ElementRef,
      import18.ResponsiveService,
      import23.NavigationService,
      import0.ChangeDetectorRef,
      import0.Renderer2
    ]
    ,(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),2,(null as any),View_StoreDetailsPanelComponent_1)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import0.ɵpid(131072,import1.AsyncPipe,[import0.ChangeDetectorRef]),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),44,'div',[[
        'class',
        'store-main'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'store-main-header'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'store-main-header-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                ',
      '\n            '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_StoreDetailsPanelComponent_2)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_StoreDetailsPanelComponent_3)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),29,'div',[[
        'class',
        'store-main-body'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),23,'div',[[
        'class',
        'store-main-body-details'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),17,'div',[[
        'class',
        'store-main-body-details-static'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),2,(null as any),View_StoreDetailsPanelComponent_4)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import0.ɵpid(131072,import1.AsyncPipe,[import0.ChangeDetectorRef]),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'store-main-body-details-static-info'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_StoreDetailsPanelComponent_5)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_StoreDetailsPanelComponent_9)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_StoreDetailsPanelComponent_10)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_StoreDetailsPanelComponent_11)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_StoreDetailsPanelComponent_12)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_StoreDetailsPanelComponent_18)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import24.StoreDetailsPanelComponent = v.component;
    const currVal_0:any = 'store';
    const currVal_1:any = ck(v,3,0,co.summary,co.canShowActions,co.showStoreImage,co.canShowMap);
    ck(v,2,0,currVal_0,currVal_1);
    ck(v,4,0);
    const currVal_2:any = (co.showStoreImage && import0.ɵunv(v,7,0,import0.ɵnov(v,8).transform(co.responsiveService.desktop$)));
    ck(v,7,0,currVal_2);
    const currVal_4:any = co.showStateWithName;
    ck(v,18,0,currVal_4);
    const currVal_5:any = co.canShowDistance;
    ck(v,21,0,currVal_5);
    const currVal_6:any = (co.showStoreImage && import0.ɵunv(v,31,0,import0.ɵnov(v,32).transform(co.responsiveService.mobile$)));
    ck(v,31,0,currVal_6);
    const currVal_7:any = (co.showAddress || co.canShowDescription);
    ck(v,37,0,currVal_7);
    const currVal_8:any = co.canShowTelephone;
    ck(v,40,0,currVal_8);
    const currVal_9:any = co.showMoreDetails;
    ck(v,43,0,currVal_9);
    const currVal_10:any = co.showStatus;
    ck(v,48,0,currVal_10);
    const currVal_11:any = co.canShowActions;
    ck(v,52,0,currVal_11);
    const currVal_12:any = co.canShowMap;
    ck(v,57,0,currVal_12);
  },(ck,v) => {
    var co:import24.StoreDetailsPanelComponent = v.component;
    const currVal_3:any = co.store.collectiveStoreName;
    ck(v,15,0,currVal_3);
  });
}
function View_StoreDetailsPanelComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-store-details-panel',([] as any[]),(null as any),(null as any),(null as any),View_StoreDetailsPanelComponent_0,RenderType_StoreDetailsPanelComponent)),
    import0.ɵdid(245760,(null as any),0,import24.StoreDetailsPanelComponent,[
      import17.SessionModel,
      import18.ResponsiveService,
      import14.OrderingContextModel,
      import0.ChangeDetectorRef
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const StoreDetailsPanelComponentNgFactory:import0.ComponentFactory<import24.StoreDetailsPanelComponent> = import0.ɵccf('woa-store-details-panel',import24.StoreDetailsPanelComponent,View_StoreDetailsPanelComponent_Host_0,{
  store: 'store',
  intention: 'intention',
  filteredOrderType: 'filteredOrderType',
  summary: 'summary',
  showStateWithName: 'showStateWithName',
  showDistance: 'showDistance',
  showStoreImage: 'showStoreImage',
  showAddress: 'showAddress',
  showDescription: 'showDescription',
  collapseText: 'collapseText',
  showTelephone: 'showTelephone',
  showMoreDetails: 'showMoreDetails',
  showStatus: 'showStatus',
  showActions: 'showActions',
  showMap: 'showMap'
}
,{
  onStoreDetails: 'onStoreDetails',
  onOrderFromStore: 'onOrderFromStore'
}
,([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/app/store/store-details-panel/store-details-panel.component.ngfactory.ts